export enum FormFieldTypes {
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  DATE_AND_TIME = 'DATE_AND_TIME',
  CHECKBOX = 'CHECKBOX'
}